import at from './prediggoObjects/at';
import bs from './prediggoObjects/bs';
import bg from './prediggoObjects/bg';
import cs from './prediggoObjects/cs';
import cz from './prediggoObjects/cz';
import da from './prediggoObjects/da';
import de from './prediggoObjects/de';
import dk from './prediggoObjects/dk';
import el from './prediggoObjects/el';
import en from './prediggoObjects/en';
import es from './prediggoObjects/es';
import et from './prediggoObjects/et';
import fi from './prediggoObjects/fi';
import fr from './prediggoObjects/fr';
import hr from './prediggoObjects/hr';
import hu from './prediggoObjects/hu';
import it from './prediggoObjects/it';
import lt from './prediggoObjects/lt';
import lv from './prediggoObjects/lv';
import nl from './prediggoObjects/nl';
import no from './prediggoObjects/no';
import pl from './prediggoObjects/pl';
import pt from './prediggoObjects/pt';
import se from './prediggoObjects/se';
import sk from './prediggoObjects/sk';
import sv from './prediggoObjects/sv';
import he from './prediggoObjects/he';
import sq from './prediggoObjects/sq';
import sr from './prediggoObjects/sr';
import ro from './prediggoObjects/ro';
import uk from './prediggoObjects/uk';
import br from './prediggoObjects/br';

export const prediggoTranslation = {
  at,
  bs,
  bg,
  cs,
  cz,
  da,
  de,
  dk,
  el,
  en,
  es,
  et,
  fi,
  fr,
  he,
  hr,
  hu,
  it,
  lt,
  lv,
  nl,
  no,
  pl,
  pt,
  ro,
  se,
  sk,
  sv,
  sr,
  sq,
  uk,
  br,
};
